(function($) {

    if ($(window).width() >= 992) {

        $('.js-toggle').on('mouseenter', function() {
            $this = $(this);
            $this.addClass('is-active');
        });
        $('.js-toggle').on('mouseleave', function() {
            $this = $(this);
            $this.removeClass('is-active');
        });

    } else {

        $('.js-toggle').on('click', function() {
            $this = $(this);

            if($this.hasClass('is-active')) {
                $this.removeClass('is-active');
            } else {
                $this.addClass('is-active');
            }
        });
    }

    $('.card-hover').each(function() {
        var toggleTop = $(this).height() / 2;

        $(this).find('.accordion-toggle').css('top', toggleTop);
    });

}(jQuery));
